import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'SSBIBehavioral',
    label: 'SSBIBehavioral',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
